import { Site } from '@debbie/common/dist/index.js';
import { InteractionType, } from '@debbie/common/dist/interactions/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import { PreviewWrapper } from '../PreviewWrapper.js';
const SMSPreview = (props) => {
    const SMS = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    return (React.createElement(PreviewWrapper, { selected: props.selected, onClick: props.onClick },
        React.createElement("h1", null,
            lang.interactionTypes[InteractionType.SMS],
            ' ',
            site === Site.Caseworker && props.interaction.aiGenerated && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginLeft: '0.3em' } }, lang.interactions.aiGenerated)),
            props.interaction.paused && (React.createElement(Badge, { theme: THEME.WARNING, style: { marginLeft: '0.3em' } }, lang.cases.casePaused)),
            React.createElement("small", { style: {
                    float: 'right',
                } }, moment(props.interaction.createdAt).format(THEME.DATE_FORMAT_LONG))),
        React.createElement("p", { className: "subject" }, SMS.text && SMS.text.substr(0, 64)),
        React.createElement("p", null,
            SMS.text && SMS.text.substr(0, 64),
            SMS.text && SMS.text.length > 64 ? '...' : ''),
        React.createElement("p", { className: "address" },
            "+",
            SMS.countryCode,
            " ",
            SMS.number)));
};
export default SMSPreview;
//# sourceMappingURL=SMSPreview.js.map